module.exports = __webpack_public_path__ + "static/reasons-b753f7d7108de5c34b6ab9e515d34a88.png";